<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div>
        </div>
        <a-button type="primary" @click="addDictionary">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        style="width: 100%"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        default-expand-all-rows
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :data-source="table.data">
        <a-table-column
          data-index="name"
          title="字典名称"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="code"
          :title="$t('CODE')||'编码'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="isActive"
          title="是否有效"
          width="180">
          <template slot-scope="text,record">
            <a-tag type="success" v-if="record.isActive==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isActive==='NO'">否</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="remark"
          title="备注"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button
              type="link"
              @click="editDictionary(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button
              type="link"
              @click="editDictionaryData(record.id)">数据
            </a-button>
            <a-button
              type="link"
              @click="deleteDictionary(record.id)">{{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :footer="null"
      :title="form.data.id?'字典编辑':'字典添加'"
      @close="closeForm"
      v-model="form.visible">
      <dictionary-edit
        v-if="form.visible"
        :dictionary-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </dictionary-edit>
    </a-modal>
    <a-modal :footer="null"
      title="字典数据"
      v-model="dataForm.visible"
      @close="getDictionaryList">
      <sys-dict-data-list
        v-if="dataForm.visible"
        :sys-dict-id="dataForm.data.id"/>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _deleteDictionary,
  _queryDictionaries,
} from '@/api/sys/sysDictionaryApi';
import DictionaryEdit from './DictionaryEdit.vue';
import SysDictDataList from './SysDictDataList.vue';


async function getDictionaryList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content, totalElements } = await _queryDictionaries({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = content;
  this.table.query.total = totalElements;
}

function addDictionary() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editDictionary(dictionaryId) {
  this.form.data.id = dictionaryId;
  this.form.visible = true;
}

function editDictionaryData(dictionaryId) {
  this.dataForm.data.id = dictionaryId;
  this.dataForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getDictionaryList();
}

async function deleteDictionary(dictionaryId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteDictionary(dictionaryId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getDictionaryList();
    },
  });
}

export default {
  name: 'DictionaryList',
  components: {
    SysDictDataList,
    DictionaryEdit,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
          name: '',
          code: '',
          isActive: 'YES',
          remark: '',
        },
        visible: false,
      },
      dataForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'name',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getDictionaryList,
    deleteDictionary,
    editDictionary,
    editDictionaryData,
    addDictionary,
    closeForm,
  },
  created() {
    this.getDictionaryList();
  },
};
</script>

<style scoped>

</style>
